var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9813 7.57703L16.979 11.4389C16.9941 16.7092 12.7279 21.0089 7.51491 21.0008C5.44423 20.9969 3.5592 20.3611 2.03125 19.2496C4.77333 24.2158 10.0302 27.571 16.0059 27.5766C24.687 27.572 31.8604 20.4516 31.9939 11.6962L31.9921 11.6597C32 11.458 31.9907 7.72478 32.0004 7.55956C31.9879 3.40552 28.6167 -0.00940954 24.4945 1.94792e-05C20.3531 -0.0078784 16.9668 3.38648 16.9813 7.57703Z",
    fill: "url(#paint0_linear_9494_16634)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50566 3.88672C3.36713 3.88672 0 7.27988 0 11.4506C0 15.6209 3.36713 19.0141 7.50566 19.0141C11.6444 19.0141 15.0113 15.6209 15.0113 11.4506C15.0113 7.27988 11.6444 3.88672 7.50566 3.88672Z",
    fill: "#0B23A9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9494_16634",
    x1: 9.0591,
    y1: 27.314,
    x2: 26.3873,
    y2: 8.26656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09DBF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B23A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo30);
export default __webpack_public_path__ + "static/media/logo30.62b6094af07ed6b9fd4f907325c1287e.svg";
export { ForwardRef as ReactComponent };